export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14680.62932a75.jpg";